export default {
  // ===== Global Status =====
  status: {
    processing: false,
    error: null,
    success: null,
    previous: null,
  },

  // ===== Generic Notification =====
  notification: {},
  notifications: [],

  // ===== Contract =====
  notificationContract: {},
  notificationContracts: [],

  // ===== Payment Schedule =====
  notificationPaymentSchedule: {},
  notificationsPaymentSchedule: [],
  notificationPaymentSchedules: [],

  // ===== Contract Call =====
  notificationCall: {},
  notificationsCall: [],
  notificationContractsCall: [],
  notificationCallEx: {},
  notificationsCallEx: [],
  notificationContractsCallEx: [],

  // ===== Sale =====
  notificationSale: {},
  notificationsSale: [],
  notificationContractSale: {},
  notificationContractsSale: [],

  // ===== Lawyer =====
  notificationLawyer: {},
  notificationsLawyer: [],

  // ===== Curriculum External =====
  notificationCurriculumExternal: {},
  notificationCurriculumExternals: [],

  // ===== Student App =====
  notificationStudentApp: {},
  notificationsStudentApp: [],
};
